import script from "./welcome.vue?vue&type=script&setup=true&lang=js"
export * from "./welcome.vue?vue&type=script&setup=true&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=81b3007a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81b3007a"]])

export default __exports__